import { createContext, useContext, useEffect, type ComponentPropsWithoutRef } from "react";
import type { Anchor } from "@nabla/api";
import { useNavigation } from "./Navigation.tsx";
import type { NavKind } from "./router.ts";

export { useNavigation };

type LinkProps = Omit<ComponentPropsWithoutRef<"a">, "href"> & {
  readonly href: string;
  readonly kind?: NavKind;
};

export function Link({ href, kind, children, ...rest }: LinkProps) {
  return (
    <a href={href} {...(kind === undefined ? {} : { "data-nav": kind })} {...rest}>
      {children}
    </a>
  );
}

export function Redirect({ to }: { readonly to: string }) {
  const { redirect } = useNavigation();
  useEffect(() => redirect(to), [redirect, to]);
  return null;
}


export const OpeningPage = createContext(false);

export const useOpeningPage = (): boolean => useContext(OpeningPage);

export function zoomOrigin(morph: string): { readonly "data-zoom-origin": string } {
  return { "data-zoom-origin": morph };
}

export const morphTarget = { "data-morph": "" } as const;

const offered = new Map<string, Anchor>();

export const offeredAnchor = (text: string): Anchor | undefined => offered.get(text);

export function askAbout(anchor: Anchor, name: string, gerenciador?: string | null): Readonly<Record<`data-ask${string}`, string>> {
  const text = JSON.stringify(anchor);
  offered.set(text, anchor);
  return {
    "data-ask": text,
    "data-ask-nome": name,
    ...(gerenciador ? { "data-ask-gerenciador": gerenciador } : {}),
  };
}

export function shortcut(key: "a" | "r" | "e" | "u"): { readonly "data-atalho": string } {
  return { "data-atalho": key };
}

export function reloadAt(path: "/" | "/conta/fator" | "/conta/acesso" | "/conta/bem-vindo"): void {
  location.assign(path);
}

export function providerPage(url: string): boolean {
  const destination = new URL(url);
  if (destination.protocol !== "https:" || destination.username !== "" || destination.password !== "") return false;
  location.assign(destination.href);
  return true;
}

export function clearQuery(): void {
  history.replaceState(history.state, "", location.pathname);
}
